import {
  CheckCircleFill,
  HeartFill,
  ChatDotsFill,
  PersonDashFill,
  XOctagonFill,
  Megaphone,
  TrashFill,
  PencilFill,
} from "react-bootstrap-icons";
import TextComponent from "../components/modals/TextComponent";
import CommentList from "../components/CommentList";
import MenuPopover from "./MenuPopover";
import EditPost from "../components/modals/EditPost";
import Avatar from "../components/reusable/Avatar";
import useTimeline from "../hooks/useTimeline";

const Timeline = ({
  authorName,
  authorEmail,
  likes,
  bookmarks,
  isEdited,
  contentImage,
  authorImage,
  businessCategory,
  contentBody,
  user,
  token,
  secondParty,
  id,
  refetch,
}) => {
  const {
    showCommentForm,
    showPopover,
    setShowPopover,
    showEdit,
    setShowEdit,
    replyContent,
    setReplyContent,
    showCommentList,
    comments,
    hasLikes,
    likeCount,
    isAuthor,
    handleCloseCommenter,
    toggleCommentForm,
    toggleCommentList,
    onLike,
    onUnlike,
    onDelete,
    onUnfollow,
    onBlock,
    onReport,
    onComment,
  } = useTimeline({ user, token, secondParty, id, likes, refetch });

  return (
    <div className="post-card">
      {/* Header */}
      <div className="post-header">
        <div className="post-author-info">
          <Avatar src={authorImage} alt={authorName} size="md" />
          <div className="post-author-details">
            <span className="post-author-name">
              {authorName}
              <CheckCircleFill
                style={{ color: "var(--accent-secondary)", fontSize: "14px" }}
                title={`${authorName} is verified`}
              />
            </span>
            <span className="post-author-meta">
              {businessCategory && <span>{businessCategory}</span>}
              {businessCategory && isEdited && <span>&middot;</span>}
              {isEdited && <span>Edited</span>}
            </span>
          </div>
        </div>

        <MenuPopover show={showPopover} setShow={setShowPopover}>
          <div className="py-1">
            {!isAuthor && (
              <>
                <button className="popover-action" onClick={onUnfollow}>
                  <PersonDashFill /> Unfollow
                </button>
                <button className="popover-action" onClick={onBlock}>
                  <XOctagonFill /> Block
                </button>
                <button className="popover-action" onClick={onReport}>
                  <Megaphone /> Report
                </button>
              </>
            )}
            {isAuthor && (
              <>
                <button className="popover-action" onClick={onDelete}>
                  <TrashFill /> Delete
                </button>
                <button
                  className="popover-action"
                  onClick={() => setShowEdit((prev) => !prev)}
                >
                  <PencilFill /> Edit
                </button>
              </>
            )}
          </div>
        </MenuPopover>
      </div>

      {/* Body */}
      <div className="post-body">
        {contentBody ?? "Loading content..."}
      </div>

      {/* Image */}
      {contentImage && (
        <img className="post-image" src={contentImage} alt="Post" />
      )}

      {/* Stats */}
      {(likeCount > 0 || comments.length > 0) && (
        <div className="post-stats">
          <span>
            {likeCount > 0 && (
              <>
                <HeartFill
                  style={{
                    color: "var(--like-color)",
                    fontSize: "14px",
                    marginRight: "4px",
                  }}
                />
                {likeCount}
              </>
            )}
          </span>
          <span>
            {comments.length > 0 &&
              `${comments.length} comment${comments.length > 1 ? "s" : ""}`}
          </span>
        </div>
      )}

      {/* Action Buttons */}
      <div className="post-actions">
        <button
          className={`post-action-btn ${hasLikes ? "liked" : ""}`}
          onClick={hasLikes ? onUnlike : onLike}
        >
          <HeartFill /> {hasLikes ? "Liked" : "Like"}
        </button>
        <button
          className={`post-action-btn ${showCommentForm ? "comment-active" : ""}`}
          onClick={toggleCommentForm}
        >
          <ChatDotsFill /> Comment
        </button>
      </div>

      {/* Comment Form Modal */}
      {showCommentForm && (
        <TextComponent
          showModal={showCommentForm}
          handleClose={handleCloseCommenter}
          handleSave={onComment}
          setContent={setReplyContent}
          content={replyContent}
          title="Post your comment"
        />
      )}

      {/* View/Collapse Comments */}
      {!showCommentForm && comments.length > 0 && (
        <div className="post-comments-section">
          <button
            className="border-0 bg-transparent w-100 text-center"
            style={{
              color: "var(--text-secondary)",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
              padding: "4px 0",
            }}
            onClick={toggleCommentList}
          >
            {showCommentList ? "Hide comments" : "View comments"}
          </button>
        </div>
      )}

      {showCommentList && (
        <div style={{ padding: "0 16px 12px" }}>
          <CommentList comments={comments} />
        </div>
      )}

      {/* Edit Modal */}
      {showEdit && (
        <EditPost
          show={showEdit}
          setShow={setShowEdit}
          user={user}
          refetch={refetch}
          grabbedId={id}
          grabbedMessage={contentBody}
          grabbedImage={contentImage}
        />
      )}
    </div>
  );
};

export default Timeline;
